import { StringFilterConfig } from '../types/filter-config';
import { FilterItemConfigOptions } from '../types/filter-item-config-options';
import { FilterStateFactoryRef } from './filter.function';
import { StringFilter } from '../types/filter';
import { QueryFilter } from '@softline/core';
import { StringFilterOperator } from '../types/filter-operators';
import { defaultFilterInputTypeFactory } from '../page-filter/helper/default-filter-input-type.factory';

export interface StringFilterOptions<T extends object> extends FilterItemConfigOptions<T, string> {
  defaultOperator?: StringFilterOperator;
  allowedOperators?: StringFilterOperator[];
}

export function stringFilter<T extends object>(
  ref: FilterStateFactoryRef<T>,
  options: StringFilterOptions<T>): void {
  const config: StringFilterConfig<T> = {
    ...options,
    type: 'string',
    defaultOperator: options.defaultOperator ?? 'in',
    allowedOperators: options.allowedOperators ?? ['equals', 'notEquals', 'startsWith', 'endsWith', 'in', 'notIn', 'contains', 'like'],
    formatter: options.formatter ?? ((o) => o),
    toQueryFilter,
    inputTypeFactory: defaultFilterInputTypeFactory
  }
  ref.addItem(config);
}

function toQueryFilter<T extends object>(filter: StringFilter<T>): QueryFilter<T> {
  switch (filter.operator) {
    case 'empty':
      return { name: filter.field, type: 'stringEmpty' }
    case 'notEmpty':
      return { name: filter.field, type: 'stringNotEmpty' }
    case 'equals':
      return { name: filter.field, type: 'stringEquals', value: filter.value}
    case 'notEquals':
      return { name: filter.field, type: 'stringNotEquals', value: filter.value}
    case 'startsWith':
      return { name: filter.field, type: 'stringStartsWith', value: filter.value}
    case 'endsWith':
      return { name: filter.field, type: 'stringEndsWith', value: filter.value}
    case 'contains':
      return { name: filter.field, type: 'stringContains', value: filter.value}
    case 'like':
      return { name: filter.field, type: 'stringLike', value: filter.value}
    case 'in':
      return { name: filter.field, type: 'stringSet', values: filter.value}
    case 'notIn':
      throw new Error('operator notIn not supported yet by the api');
  }
}
